export const appName = 's7'


// WEBPACK FOOTER //
// ./src/config.js